/**
 * @file BlogPage.js
 * @description Manages the Blog page and interactions.
 * (REFACTORED: Removed fake boot loader)
 */

export class BlogPage {
    constructor(services) {
        this.contentManager = services.content;
        this.eventBus = services.eventBus; // Removed StateManager
        this.dom = {
            content: document.querySelector('#blog .content-block'),
        };
    }

    init() {
        this.render();
        this.addListeners();
    }

    render() {
        if (!this.dom.content) return;
        const posts = this.contentManager.getBlogPosts();
        
        const postsByCategory = posts.reduce((acc, post) => {
            const category = post.category || 'Uncategorized';
            if (!acc[category]) acc[category] = [];
            acc[category].push(post);
            return acc;
        }, {});

        let html = '<h2 class="page-title">Blogs</h2>';
        // Ensure this list matches your blog-template.md options exactly
        const categoryOrder = ['Project Deep-Dive', 'CTF Writeups', 'Certifications', 'Career & Systems Thinking', 'Uncategorized'];

        for (const category of categoryOrder) {
            if (!postsByCategory[category]) continue; 
            
            // FIX: Changed 'Project Deep-Dives' to 'Project Deep-Dive' (singular)
            const isOpen = category === 'Project Deep-Dive' ? 'open' : '';
            
            html += `
            <details class="blog-category" ${isOpen}>
                <summary>${category}</summary>
                <div class="blog-posts-list">
                    ${postsByCategory[category].map(post => `
                        <a href="#" class="blog-post-item" data-post-id="${post.id}">
                            <div class="blog-post-details">
                                <h3 class="blog-post-title">${post.title}</h3>
                                <div class="blog-post-stats">
                                    <span>${post.date}</span>
                                </div>
                                <p class="blog-post-excerpt">${post.excerpt}</p>
                            </div>
                        </a>
                    `).join('')}
                </div>
            </details>
            `;
        }
        this.dom.content.innerHTML = html;
    }

    addListeners() {
        if (!this.dom.content) return;
        
        this.dom.content.addEventListener('click', (e) => {
            const item = e.target.closest('.blog-post-item');
            if (!item) return;
            
            e.preventDefault();
            const postId = item.dataset.postId;
            
            // DIRECT ACTION: Open the modal immediately. No loading sequences.
            this.eventBus.emit('modal:open:blog', { postId });
        });
    }
}